import { render, staticRenderFns } from "./UserEditBtn.vue?vue&type=template&id=1669300d&"
import script from "./UserEditBtn.vue?vue&type=script&lang=js&"
export * from "./UserEditBtn.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports